import styled, { css, keyframes } from 'styled-components';
import { colors } from 'assets/styled/tokens/colors';
import { medias } from 'assets/styled/tokens/medias';

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const StyledUserMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
  margin-left: 16px;
`;

export const UserGreeting = styled.div`
  font-size: 13px;
  color: ${colors.gray};
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    font-weight: 500;
  }

  @media (max-width: ${medias.tablet}) {
    display: none;
  }
`;

export const UserIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f28c28; // Orange from the original design
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  transition: all 0.2s ease;

  &:hover {
    animation: ${pulse} 0.5s ease;
  }
`;

export const MenuDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 100;
  overflow: hidden;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${props => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease-in-out;
  animation: ${props =>
    props.isOpen &&
    css`
      ${fadeIn} 0.2s ease-out
    `};
`;

export const MenuItem = styled.a`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  color: ${colors.gray};
  text-decoration: none;

  &:hover {
    background-color: ${colors.lightGray};
  }

  svg {
    color: #f28c28;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${colors.lightGray};
  margin: 4px 0;
`;
